import React from "react";
import { useEffect, useState } from "react";
import { api } from 'api';

/**
 * Hook para obtener las recepciones de NH3 y sus totales
 * @returns {Object} - Objeto con las funciones para obtener las recepciones de NH3 y el estado de carga
 */
export const RecepcionesNH3Api = () => {
    const [cargando, setCargando] = useState(false);

    const getRecepcionesNH3 = async (params) => {
        try {
            setCargando(true);
            const response = await api.get('finca_bonif_amoniaco/get_recepciones_amoniaco', params);
            return response;
        } catch (error) {
            console.error(error);
            return { results: 0, data: [] };
        } finally {
            setCargando(false);
        }
    }

    const getTotalesNH3 = async (params) => {
        try {
            setCargando(true);
            const response = await api.get('finca_bonif_amoniaco/get_totales_amoniaco', params);
            return response;
        } catch (error) {
            console.error(error);
            return {};
        } finally {
            setCargando(false);
        }
    }



    return {
        getRecepcionesNH3,
        getTotalesNH3,
        cargando
    }
}
